module.exports = __webpack_public_path__ + "static/media/TW-father-joe-tablet-738x57.3952f735.jpg";